<template>
  <div class="record-wrap">
    <section class="search-wrap">
      <van-search
        v-model="searchText"
        placeholder="输入学生姓名进行查询"
        show-action
        shape="round"
        @search="onSearch"
      >
        <div class="screen-btn" :class="{active: showScreen}" slot="action" @click="showScreen = !showScreen">筛选
          <van-icon name="play"/>
        </div>
      </van-search>

      <van-list class="refreshWrap" v-model="isRefresh" @load="onLoad" finished-text="没有更多了" :finished="finished">
        <ul class="record-list">
          <li class="record" v-for="item in recordList" :key="item.LeaveApplicationID" @click="openDetail(item)">
            <h3>{{item.StudentName}}</h3>
            <div class="info">
              <img :src="cardImgUrl" alt="">
              <div class="right-con">
                <p>
                  <span class="date">{{transferDate(item.StartTime, 'MM/dd')}}</span>
                  <span class="other-date">{{item.StartDay}}{{item.StartAMorPMOrderFullName}}</span>
                </p>
                <p>
                  <span class="date">{{transferDate(item.EndTime, 'MM/dd')}}</span>
                  <span class="other-date">{{item.EndDay}}{{item.EndAMorPMOrderFullName}}</span>
                </p>
              </div>
            </div>
            <p class="type-info">请假类型： {{item.LeaveTypeName}}</p>
            <img :src="approvalImg[item.ApplicationState -1]" class="type-icon" alt="type-img">
          </li>
        </ul>
      </van-list>
    </section>
    <screen-items v-show="showScreen" :setCondition="setCondition"></screen-items>
  </div>
</template>
<script>
  import ScreenItems from '../../components/ScreenItems'

  import xy from "@/common/utils";

  import {Notify} from 'vant';

  const cardImgUrl = require('@/assets/attendance/data_ask.png');
  const approvalImg = [
    require('@/assets/attendance/approval-1.png'),
    require('@/assets/attendance/approval-2.png'),
    require('@/assets/attendance/approval-3.png'),
    require('@/assets/attendance/approval-4.png'),
    require('@/assets/attendance/approval-5.png'),
  ];
  export default {
    name: 'StudentLeaveSubApproval',
    components: {
      ScreenItems,
    },
    data() {
      return {
        approvalImg: approvalImg,
        cardImgUrl: cardImgUrl,
        showScreen: false,
        isRefresh: false,
        finished: false,

        recordList: [],

        searchText: '',
        leaveTypeID: 0,
        timeType: 0,
        applicationState: 0,

        pageIndex: 0,
        pageSize: 15,
      }
    },
    created() {

    },
    methods: {
      transferDate: xy.transferDate,
      openDetail(item) {
        let params = {
          status: item.ApplicationStateName,
          name: item.StudentName,
          createdDate: item.CreatedDate,
          startTime: item.StartTime.slice(0, 10) + item.StartKey,
          endTime: item.EndTime.slice(0, 10) + item.EndKey,
          leaveImg: item.LeavePermitSrc,
          substituteName: item.SubstituteName,
          desc: item.DeniedDescription,
          leaveTypeName: item.LeaveTypeName,
          LeaveApplicationID:item.LeaveApplicationID,
          icon:item.Icon,
          originPage: 'student',
        }
        this.$router.push({path: '/home/StudentLeave/Detail', query: params})
      },
      onSearch() {
        this.finished = false;
        this.pageIndex = 0;
        this.recordList = [];
        this.onLoad()
      },
      setCondition(leaveTypeID, timeType, applicationState) {
        this.searchText = '';
        this.showScreen = false;
        this.pageIndex = 0;
        this.finished = false;
        this.leaveTypeID = leaveTypeID;
        this.timeType = timeType;
        this.applicationState = applicationState;
        this.recordList = [];
        this.onLoad()
      },

      async getList() {
        var params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          studentName: this.searchText,
          leaveTypeID: this.leaveTypeID,
          timeType: this.timeType,
          applicationState: this.applicationState
        }

        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/StudentLeaveMb/GetPage', params);
        if (res.success) {
          // 加载状态结束
          this.isRefresh = false;

          if (res.data) {
            this.totalItems = res.data.totalRecords
            this.recordList = this.recordList.concat(res.data.data)
          }
          console.log(this.recordList.length)
          console.log(this.totalItems)
          if (this.recordList.length >= this.totalItems) {
            this.finished = true;
          }
        } else {
          Notify({type: 'danger', message: res.msg});
        }

      },
      onLoad(params = null) {
        this.pageIndex++
        params = Object.assign({pageIndex: this.pageIndex}, params);
        this.getList(params)

      }
    }
  }
</script>
<style lang="less" scoped>
  .record-wrap {
    .search-wrap {
      margin-top: 10px;

      .screen-btn.active {
        .van-icon-play {
          transform: rotate(270deg);
          margin-left: 5px;
        }
      }

      .screen-btn {
        width: 120px;
        color: #4A98FD;

        .van-icon-play {
          transform: rotate(90deg);
          margin-left: 5px;
        }
      }
    }

    .refreshWrap {
      .record-list {
        padding: 0 20px;

        .record {
          margin-top: 10px;
          padding: 10px 20px;
          background: #ffffff;
          border-radius: 8px;
          position: relative;

          h3 {
            color: #333333;
            font-size: 30px;
            font-weight: bold;
          }

          .info {
            margin-top: 30px;
            display: flex;

            img {
              width: 13px;
              height: 73px;
              margin-top: 10px;
              margin-right: 10px;
            }

            .right-con {
              font-size: 26px;

              .date {
                margin-right: 10px;
              }

              p:last-child {
                margin-top: 40px;
              }
            }
          }

          .type-info {
            margin-top: 33px;
            background: rgba(246, 246, 247, 1);
            border-radius: 14px 0px 14px 0px;
            font-size: 24px;
            color: #666666;
            display: inline-block;
            padding: 5px 10px;
          }

          .type-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 104px;
            height: 104px;
          }
        }
      }
    }
  }
</style>
